export default __webpack_public_path__ + "static/media/v5.9a125b68.jpg";